module.exports = __webpack_public_path__ + "img/66ne.dde1eaa8.svg";